// fetchProducts.js
import { authAxios } from "../utils";
import { authContext } from '../adalConfig';
import { GetUserURL, GetOfficeListingPointOfContactURL , DeleteEmployeeInformationURL, UpdateUserURL, GetAllOfficeListingPointOfContactEmeaURL } from '../constants';
import {
    fetchAllOfficeListingWithPointOfContactError, fetchAllOfficeListingWithPointOfContactPending, fetchAllOfficeListingWithPointOfContactSuccess
} from '../actions';
let loginNameWithDomain = authContext.getCachedUser() ? authContext.getCachedUser().profile.upn : '';

export const extractDataFromAPIToOfficeListingPOCObject = (responses) => {
    return responses.map((x, index) => {
        return ({
            'key': x.key,
            'office': x.office,
            'costCenter': x.costCenter,
            'contact': x.contact,
            'shippingInfo': x.shippingInfo,
            'loginName': x.loginName,
            'email': x.email,
            'country': x.country,
            'phoneNumber': x.phoneNumber,
            'region': x.region
        })
    });
}


export const fetchAllOfficeListingWithPointOfContacts = (role = 'CORP') => async (dispatch, getState) => {
    dispatch(fetchAllOfficeListingWithPointOfContactPending());
    authAxios.get(GetOfficeListingPointOfContactURL + `?role=${role}`)
        .then(response => {
            let officeListingPointOfContacts = extractDataFromAPIToOfficeListingPOCObject(response.data);
            dispatch(fetchAllOfficeListingWithPointOfContactSuccess(officeListingPointOfContacts));
            return response;
        })
        .catch(error => {
            dispatch(fetchAllOfficeListingWithPointOfContactError(error));
        })
}

export const fetchAllOfficeListingWithPointOfContactsEmea = (role = 'CORP', country = null) => async (dispatch, getState) => {
    dispatch(fetchAllOfficeListingWithPointOfContactPending());
    /*authAxios.get(GetAllOfficeListingPointOfContactEmeaURL + `?role=${role}`)*/
    let url = GetAllOfficeListingPointOfContactEmeaURL + `?role=${role}`;
    if (country) {
        url += `&country=${encodeURIComponent(country)}`;
    }
        authAxios.get(url)
        .then(response => {
            let officeListingPointOfContactsEmea = extractDataFromAPIToOfficeListingPOCObject(response.data);
            dispatch(fetchAllOfficeListingWithPointOfContactSuccess(officeListingPointOfContactsEmea));
            return response;
        })
        .catch(error => {
            dispatch(fetchAllOfficeListingWithPointOfContactError(error));
        })
}